import { render, staticRenderFns } from "./NotificationQueue.vue?vue&type=template&id=165d98d5&scoped=true&"
import script from "./NotificationQueue.vue?vue&type=script&lang=js&"
export * from "./NotificationQueue.vue?vue&type=script&lang=js&"
import style0 from "./NotificationQueue.vue?vue&type=style&index=0&id=165d98d5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165d98d5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VIcon,VSnackbar})
